module.exports = __webpack_public_path__ + "img/mochila-couro.21f7f657.jpg";